module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "companies-page"
  }, [_c('div', {
    class: _vm.loading ? 'hidden' : ''
  }, [_c('filter-results', {
    attrs: {
      "refresh": _vm.key
    },
    on: {
      "fetchDataComplete": _vm.fetchDataComplete
    }
  })], 1), _vm._v(" "), _c('company-create', {
    attrs: {
      "isOpen": _vm.open,
      "company": _vm.company
    },
    on: {
      "save": _vm.create,
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "companies-page-loader",
    class: _vm.loading ? '' : 'hidden'
  }, [_c('loading')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c844fc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/companies/Companies.vue
// module id = 1933
// module chunks = 0